export const ADD_ONE_COLUMN = "ADD_ONE_COLUMN";
export const ADD_TWO_COLUMN = "ADD_TWO_COLUMN";
export const ADD_THREE_COLUMN = "ADD_THREE_COLUMN";
export const ADD_FOUR_COLUMN = "ADD_FOUR_COLUMN";
export const FORCE_UPDATE = "FORCE_UPDATE";
export const RELOAD_DATA = "RELOAD_DATA";
